// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__KAGCB","action":"styles_action__gFWxc","modal":"styles_modal__mfUe6"};